import { Directive, ElementRef, HostListener } from "@angular/core";

@Directive({ selector: 'input[type="number"]' })
export class NumericFieldDirective {
    readonly acceptedKeys = ["0", "1", "2", "3", "4", "5", "6", "7", "8", "9", "-", "."];
    readonly additionalKeys = ["Enter", "Tab", "Backspace", "ArrowLeft", "ArrowRight"];
    private lastKey: string = "";

    constructor(private el: ElementRef) {}

    @HostListener("keydown", ["$event"]) down(event: KeyboardEvent) {
        if (event.ctrlKey || event.metaKey) {
            return;
        }

        if (!this.acceptedKeys.includes(event.key) && !this.additionalKeys.includes(event.key)) {
            event.preventDefault();
            return;
        }

        if ((event.key === "-" && this.lastKey === "-") || (event.key === "." && this.lastKey === ".")) {
            event.preventDefault();
            return;
        }

        this.lastKey = event.key;
    }
}
